<!-- desktop template -->
<div *appIsDesktop>
  <app-quotes-subsections-toggles [activeTab]="activeTab.Orders" [isOnAccountsPage]="isOnAccountsPage"></app-quotes-subsections-toggles>

  @if (isLoading) {
    <div id="loadingContainer" class="overlay full">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner id="ordersLoader" progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }

  <div id="tableContainer" class="table-container">
    <ds-paper id="orderListDesktopPaper" borderRadius="radius_S" insidePaddingTop="top-spacing_L" insidePaddingBottom="bottom-spacing_L"
      insidePaddingLeft="left-spacing_XL" insidePaddingRight="right-spacing_XL">

      @if (dataLoaded.templateValues) {
        <app-quotes-subsections-filter-form id="orderListDesktopFilterForm" (resetSort)="resetSortIndicator($event)"
          (resetPage)="resetPage()" [getListMethod]="getListMethod" [sortKey]="orderKey"
          [templateValuesType]="templateValues.QuoteType" [label]="appStrings.menu_Orders"
          [isOnAccountsPage]="isOnAccountsPage" [bpNumber]="bpNumber" [activeTab]="activeTab.Orders">
        </app-quotes-subsections-filter-form>
      }

      <div [hidden]="!totalRecords">
        <ds-table id="ordersTable" mat-table matSort [dataSource]="orderList" (matSortChange)="sortData($event)"
          [matSortDisabled]="totalRecords < 2" [displayedColumns]="displayedColumns" [isWithRadio]="isWithRadio"
          (selectionChange)="onRadioChange($event)">
          <ng-container matColumnDef="accountManager">
            <th id="accountManagerHeader" mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ appStrings.quoteDetails_AccountManager }}
            </th>
            <td [id]="'accountManager_'+ rowNum" mat-cell *matCellDef="let quote;let rowNum = dataIndex">
              {{ quote.accountManagerName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="accountName">
            <th id="accountNameHeader" mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ appStrings.accounts_labelName }}
            </th>
            <td [id]="'accountName_'+ rowNum" mat-cell *matCellDef="let order;let rowNum = dataIndex">
              @if (order.accountName) {
                {{ order.accountName }}
              } @else {
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="bpNumber">
            <th id="bpNumberHeader" mat-header-cell *matHeaderCellDef>
              {{ appStrings.quote_bpLabel }}
            </th>
            <td [id]="'bpNumber_'+ rowNum" mat-cell *matCellDef="let order;let rowNum = dataIndex">
              {{ order.bpNumber }}
            </td>
          </ng-container>
          <ng-container matColumnDef="contactName">
            <th id="contactNameHeader" mat-header-cell *matHeaderCellDef>{{ appStrings.label_contact }}</th>
            <td [id]="'contactName_'+ rowNum" mat-cell *matCellDef="let order;let rowNum = dataIndex">
              {{ order.contactName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="orderName">
            <th id="orderNameHeader" mat-header-cell *matHeaderCellDef>{{ appStrings.order_quoteName }}</th>
            <td mat-cell *matCellDef="let order;let dataIndex = dataIndex" [id]="appStrings.order_quoteName+'_'+dataIndex">
              @if (order.quoteName) {
                <span>{{order.quoteName}}</span>
              }
              @if (!order.quoteName) {
                <span>—</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="orderNo">
            <th id="orderNoHeader" mat-header-cell *matHeaderCellDef>
              {{ isOnAccountsPage ? appStrings.label_orderNumber : appStrings.label_orderNo }}
            </th>
            <td [id]="'quoteNumber_'+ rowNum" mat-cell *matCellDef="let order;let rowNum = dataIndex">
              {{ order.quoteNumber }}
            </td>
          </ng-container>
          <ng-container matColumnDef="orderDate">
            <th id="orderDateHeader" mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ appStrings.label_orderDate }}
            </th>
            <td [id]="'quoteDate_'+ rowNum" mat-cell *matCellDef="let order;let rowNum = dataIndex">
              {{ order.quoteDate | date: dateFormat }}
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th id="typeHeader" mat-header-cell *matHeaderCellDef>
              {{ isOnAccountsPage ? appStrings.label_orderType : appStrings.label_type }}
            </th>
            <td [id]="'quoteType_'+ rowNum" mat-cell *matCellDef="let order;let rowNum = dataIndex">
              {{ order.quoteType === 0 ? '-' : templateValues.QuoteType[order.quoteType] }}
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th id="statusHeader" mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ appStrings.label_status }}
            </th>
            <td [id]="'quoteStatus_'+ rowNum" mat-cell *matCellDef="let order;let rowNum = dataIndex">
              {{ templateValues.QuoteStatus[order.quoteStatusId] }}
            </td>
          </ng-container>
          <ng-container matColumnDef="total">
            <th id="totalHeader" mat-header-cell *matHeaderCellDef mat-sort-header class="total-header">
              {{ appStrings.label_total }}
            </th>
            <td [id]="'total_'+ rowNum" mat-cell *matCellDef="let order;let rowNum = dataIndex" class="total">
              {{ order.total | currency: order.currencySign }}
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th id="actionHeader" mat-header-cell *matHeaderCellDef></th>
            <td mat-cell [id]="'action_'+ rowNum" *matCellDef="let quote;let rowNum = dataIndex"
              class="action-container">
              @if (quote.bpNumber) {
                <ds-button size="medium" type="tertiary" variant="label-icon" icon="visibility-outlined"
                  iconStyle="material-icons-outlined" [id]="'view_'+rowNum" (onClick)="navigateToOrder(quote.id, quote.bpNumber)"
                  label="{{ appStrings.button_view }}" iconPosition="left">
                </ds-button>
              } @else {
                <ds-button size="medium" type="tertiary" variant="label-icon" icon="visibility-outlined"
                  iconStyle="material-icons-outlined" [id]="'view_'+rowNum" (onClick)="navigateToOrder(quote.id, quote.bpNumber)"
                  label="{{ appStrings.button_view_2 }}" iconPosition="left">
                </ds-button>
              }
            </td>
          </ng-container>
        </ds-table>
      </div>

      @if (isPartialLoading) {
        <div id="loadingPartialResults" class="searching-row row-loading"><span id="hourglassLoading"
        class="crm-industrial-font icon-hourglass"></span>
        {{ appStrings.loading_stillSearching }}
      </div>
    }
    @if (!totalRecords && !isLoading && !isPartialLoading) {
      <div id="emptyOrdersList" class="no-results">
        {{ appStrings.noEntriesFound }}
      </div>
    }

    @if (totalRecords) {
      <div id="paginationContainerDesktop" class="pagination-container-desktop">
        <div id="pageCount" class="page-count">
          @if (!isLoading && !isPartialLoading) {
            <div id="pageCountText">
              <b id="pageRange">{{ pageOffset + 1 }} - {{ pageOffset + (orderList?.length ?? 0) }}</b> {{appStrings.pagination_of}} <b id="totalRecordsCount">{{ totalRecords }}</b>
            </div>
          }
        </div>
        <div id="transactionHistoryListPaginator">
          <ds-pagination
            id="ordersPagination"
            [totalPages]="totalPages"
            paginationDisplay="large"
            buttonTypes="nextPrevFirstLast"
            (pageChanged)="loadPage($event)"
          ></ds-pagination>
        </div>
        <div class="flex-item-2"></div>
      </div>
    }
  </ds-paper>
</div>
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">
  @if (isLoading) {
    <div class="overlay full" id="orders-mobile-loadingSpinner">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }

  @if (dataLoaded.templateValues) {
    <app-quotes-subsections-filter-form id="orderListMobileFilterForm" (resetSort)="resetSortIndicator($event)"
      (resetPage)="resetPage()" [getListMethod]="getListMethod" [sortKey]="orderKey"
      [templateValuesType]="templateValues.QuoteType" [label]="appStrings.menu_Orders"
      [isOnAccountsPage]="isOnAccountsPage" [bpNumber]="bpNumber">
      <app-quotes-subsections-toggles [activeTab]="activeTab.Orders"></app-quotes-subsections-toggles>
    </app-quotes-subsections-filter-form>
  }

  @for (order of orderList; track order; let i = $index) {
    <mat-expansion-panel [id]="'orderCard_'+i" class="mobile-card two-columns tall blue-border" [expanded]="false">
      <mat-expansion-panel-header [id]="'orderCardHeader_'+i">
        <mat-panel-title id="order-card-header-container" class="card-header-container">
          <span [id]="'order-card-header_'+i" class="card-header">
            <span [id]="'order-card-title_'+i" class="title">
              {{ order.accountName ?? '-'}}
            </span>
            <span [id]="'order-card-subtitle_'+i" class="subtitle">
              {{ order.total | currency: order.currencySign }}
            </span>
          </span>
          <span [id]="'order-card-header-action_'+i" class="card-header-action">
            <ds-button size="medium" type="tertiary" variant="icon-only" icon="visibility" iconStyle="material-icons-outlined" [id]="'edit_'+i"
              (onClick)="navigateToOrder(order.id, order.bpNumber)">
            </ds-button>
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ds-divider [id]="'orderCardDivider_'+i"></ds-divider>
      <div [id]="'orderCardContent_'+i" [id]="'orderCardContent_'+i" class="content">
        <div [id]="'orderCardRow1_'+i" class="row">
          <div [id]="'orderCardRow1Col1_'+i" class="column">
            <typography [id]="'accountManager_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteDetails_AccountManager }} </typography>
            <typography [id]="'accountManager_'+i" variant="body-2" weight="medium"> {{ order.accountManagerName ?? '-' }} </typography>
          </div>
          <div [id]="'orderCardRow1Col2_'+i" class="column">
            <typography [id]="'bpNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quote_bpLabel }} </typography>
            <typography [id]="'bpNumber_'+i" variant="body-2" weight="medium"> {{ order.bpNumber ?? '-'}} </typography>
          </div>
        </div>
        <div [id]="'orderCardRow2_'+i" class="row">
          <div class="column">
            <typography [id]="'contact_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_contact }} </typography>
            <typography [id]="'contact_'+i" variant="body-2" weight="medium"> {{ order.contactName }} </typography>
          </div>
          <div [id]="'orderCardRow2Col2_'+i" class="column">
            <typography [id]="'quoteName_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.order_quoteName }} </typography>
            <typography [id]="'quoteName_'+i" variant="body-2" weight="medium"> {{ order.quoteName ?? '-' }} </typography>
          </div>
        </div>
        <div [id]="'orderCardRow3_'+i" class="row">
          <div [id]="'orderCardRow3Col1_'+i" class="column">
            <typography [id]="'orderNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ isOnAccountsPage ? appStrings.label_orderNumber : appStrings.label_orderNo }} </typography>
            <typography [id]="'orderNumber_'+i" variant="body-2" weight="medium"> {{ order.quoteNumber ?? '-' }} </typography>
          </div>
          <div [id]="'orderCardRow3Col2_'+i" class="column">
            <typography [id]="'orderDate_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_orderDate }} </typography>
            <typography [id]="'orderDate_'+i" variant="body-2" weight="medium"> {{ order.quoteDate | date: dateFormat }} </typography>
          </div>
        </div>
        <div [id]="'orderCardRow4_'+i" class="row">
          <div [id]="'orderCardRow4Col1_'+i" class="column">
            <typography [id]="'orderType_label_'+i" class="label" variant="caption-2" weight="regular"> {{ isOnAccountsPage ? appStrings.label_orderType : appStrings.label_type }} </typography>
            <typography [id]="'orderType_'+i" variant="body-2" weight="medium"> {{ order.quoteType === 0 ? '-' : templateValues.QuoteType[order.quoteType] }} </typography>
          </div>
          <div [id]="'orderCardRow4Col2_'+i" class="column">
            <typography [id]="'status_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_status }} </typography>
            <typography [id]="'status_'+i" variant="body-2" weight="medium"> {{ templateValues.QuoteStatus[order.quoteStatusId] ?? '-'}} </typography>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  }
  @if (totalRecords > 0) {
    <div id="paginationContainerMobile" class="pagination-container">
      <ds-paper id="orderListMobilePaginationPaper" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S">
        <div id="mobilePagination" class="pagination">
          <ds-pagination
            [totalPages]="totalPages"
            paginationDisplay="small"
            buttonTypes="nextPrevFirstLast"
            (pageChanged)="loadPage($event)"
          ></ds-pagination>
        </div>
      </ds-paper>
    </div>
  }
  @if (!totalRecords && !isLoading && !isPartialLoading) {
    <div id="emptyOrdersList" class="no-results">
      {{ appStrings.noEntriesFound }}
    </div>
  }
</div>